import { Component } from '@angular/core';
import { MethodBase } from '../base/base.component';
import { AuthMethodViewModel, HardwareTokenAuthMethodViewModel } from '../../../../services/identity';
import { FormBuilder, Validators } from '@angular/forms';

@Component({
  selector: 'app-method-hardware-token',
  standalone: false,
  templateUrl: './hardware-token.component.html',
  styleUrl: './hardware-token.component.scss'
})
export class HardwareTokenComponent extends MethodBase {

  private hardwareTokenMethod: HardwareTokenAuthMethodViewModel;

  private tokens = [];
  private tokensBuffer = [];
  private bufferSize = 20;
  private numberOfItemsFromEndBeforeFetchingMore = 10;
  private loading = false;

  constructor(
    protected fb: FormBuilder
  ) {
    super();
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this.setup();
    this.monitorFormStatus();
  }

  setup(): void {
    this.hardwareTokenMethod = this.method as HardwareTokenAuthMethodViewModel;
    this.form = this.fb.group({
      tokenId: [this.hardwareTokenMethod.tokenId, Validators.required]
    })
    this.loadHardwareTokens();
  }
  cancel(): void {
    this.setup();
  }
  getMethod(): AuthMethodViewModel {
    this.hardwareTokenMethod.tokenId = this.form.value.tokenId;
    return this.hardwareTokenMethod;
  }

  loadHardwareTokens() {
    this.subscriptions.add(this.options.functions.getHardwareTokens(this.options.org.id, this.options.user.username).subscribe(
      (data: any) => {
        this.tokens = data;
        this.tokensBuffer = this.tokens.slice(0, this.bufferSize);
        //if (this.isEdit) {
        //  this.hardwareAuthType();
        //}
      }));
  }

  //hardwareAuthType() {
  //  const element = this.tokens.find((element: any) => element.type === +this.authTypeData.source && element.seed === this.authTypeData.code && element.id === +this.authTypeData.recipient);
  //  this.tokenChange(element);
  //  this.hardwareToken.setValue(element);
  //}

  tokenChange(item: any) {
    if (item) {
      //this.hardwareModelData.serialId = item.serialId;
      //this.hardwareModelData.source = item.type;
      //this.hardwareModelData.code = item.seed;
      //this.hardwareModelData.recipient = item.id;
    }
  }

  onSearch(event: any) {
    if (event.term === '') {
      this.tokensBuffer = this.tokens.slice(0, this.bufferSize);
    }
    else {
      const records = this.tokens.filter((x: any) => x.serialId.indexOf(event.term) !== -1);
      this.tokensBuffer = records;
    }
  }

  onScroll({ end }: any) {
    if (this.loading || this.tokens.length <= this.tokensBuffer.length) {
      return;
    }

    if (end + this.numberOfItemsFromEndBeforeFetchingMore >= this.tokensBuffer.length) {
      this.fetchMoreTokens();
    }
  }

  private fetchMoreTokens() {
    const length = this.tokensBuffer.length;
    const remainingData = this.tokens.slice(length, this.bufferSize + length);
    this.loading = true;
    setTimeout(() => {
      this.loading = false;
      this.tokensBuffer = this.tokensBuffer.concat(remainingData);
    }, 200)
  }

}
